import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/** Save / delete / download actions for a single incident. */
export const useIncidentActions = ({ incident, draft, onUpdated, onDeleted, setDirty }) => {
  const [saving, setSaving] = useState(false);
  const [downloading, setDownloading] = useState("");

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/incidents/${incident.id}`, {
        title: draft.title,
        location: draft.location,
        people_involved: draft.people_involved,
        description: draft.description,
        severity: draft.severity,
        status: draft.status,
        transcript: draft.transcript,
      });
      onUpdated(data);
      setDirty(false);
      toast.success("Incident saved");
    } catch {
      toast.error("Failed to save");
    } finally {
      setSaving(false);
    }
  };

  const remove = async () => {
    try {
      await api.delete(`/incidents/${incident.id}`);
      toast.success("Incident deleted");
      onDeleted(incident.id);
    } catch {
      toast.error("Failed to delete");
    }
  };

  const blobDownload = async (path, filename, key) => {
    setDownloading(key);
    try {
      const res = await api.get(path, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Download failed");
    } finally {
      setDownloading("");
    }
  };

  const exportPdf = () =>
    blobDownload(`/incidents/${incident.id}/pdf`, `incident-${incident.id}.pdf`, "pdf");

  return { saving, downloading, save, remove, exportPdf };
};
